<form [formGroup]="formGroup">
  <div class="bpaas-login">
    <div class="card">
      <div class="flex flex-column align-items-center justify-content-center card-container h-screen">
        <p-card class="xl:max-w-25rem md:max-w-25rem sm:max-w-screen">
          <div class="grid p-fluid" pFocusTrap>
            <div class="col-12 text-2xl font-medium">Sign in to BPaaS</div>
            <div class="col-12">
                <label for="tenant">Tenant</label>
                <input type="text" pInputText formControlName="tenant"
                  id="tenant"
                  pAutoFocus [autofocus]="true"
                  [ngClass]="{'ng-dirty': formControlInvalid('tenant')}">
                <div *ngIf="formControlInvalid('tenant')">
                  <small class="p-error"
                    *ngIf="formControl('tenant').errors?.['required']">
                    {{ 'message.validation.required' | translate }}
                  </small>
                </div>
            </div>
            <div class="col-12">
                <label for="username">Username</label>
                <input type="text" pInputText formControlName="username"
                  id="username"
                  [ngClass]="{'ng-dirty': formControlInvalid('username')}">
                <div *ngIf="formControlInvalid('username')">
                  <small class="p-error"
                    *ngIf="formControl('username').errors?.['required']">
                    {{ 'message.validation.required' | translate }}
                  </small>
                </div>
            </div>
            <div class="col-12">
              <label for="password">Password</label>
              <input type="password" pPassword [feedback]="false" formControlName="password"
                id="password"
                [ngClass]="{'ng-dirty': formControlInvalid('password')}">
              <div *ngIf="formControlInvalid('password')">
                <small class="p-error"
                  *ngIf="formControl('password').errors?.['required']">
                  {{ 'message.validation.required' | translate }}
                </small>
              </div>
            </div>
            <div class="col-12">
              <button type="button" pButton pRipple label="Sign in"
                (click)="signIn()"></button>
            </div>
          </div>
          <div class="grid p-fluid">
            <div class="col-12">
              <p-divider align="center">
                <b>or</b>
              </p-divider>
            </div>
            <div class="col-12">
              <button type="button" pButton pRipple class="p-button-outlined"
                icon="pi pi-microsoft" label="Sign in with Microsoft"
                (click)="signInAad()"></button>
            </div>
          </div>
        </p-card>
      </div>
    </div>
  </div>
</form>

<!-- 整個系統的彈出訊息顯示 -->
<p-toast position="bottom-right" [breakpoints]="{'920px': {width: '95%'}}" [preventOpenDuplicates]="true">
  <ng-template let-message pTemplate="message">
    <span [class]="'p-toast-message-icon pi' + (message.icon ? ' ' + message.icon : '')"
      [ngClass]="{'pi-info-circle': message.severity == 'info',
        'pi-exclamation-triangle': message.severity == 'warn',
        'pi-times-circle': message.severity == 'error',
        'pi-check' :message.severity == 'success'}">
    </span>
    <div class="p-toast-message-text">
        <div class="p-toast-summary">{{ message.summary | translate }}</div>
        <div class="p-toast-detail">{{ message.detail | translate: message.data }}</div>
    </div>
  </ng-template>
</p-toast>
